<template>
  <div class="recordsTable">
    <div class="recordsTable__items">
      <el-tabs
        v-model="activeName"
        class="recordsTable__tabs"
      >
        <el-tab-pane
          v-for="tab in tabs"
          :key="tab.value"
          v-loading="loading"
          class="recordsTable__tabs-pane"
          :label="tab.label"
          :name="tab.value"
        >
          <record-card
            v-for="record in paginatedRecords()"
            :key="record.id"
            :record="record"
            @dialog="updateDialog"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <el-pagination
        layout="prev, pager, next"
        hide-on-single-page
        :current-page="currentPage"
        :page-size="pageSize"
        :pager-count="pagerCount"
        :total="total"
        @current-change="currentPageChange"
      >
      </el-pagination>
    </div>
    <record-dialog
      v-if="dialogVisible"
      :visible="dialogVisible"
      :record-id="dialogRecord"
      @close="closeDialog"
      @update="updateRecord"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RecordCard from '@/components/records/RecordCard'
import RecordDialog from '@/components/records/RecordDialog'

export default {
  name: "RecordsTable",
  components: {
    RecordCard,
    RecordDialog
  },
  data: () => ({
    loading: false,
    dialogVisible: false,
    dialogRecord: null,
    activeName: 'all',
    pagerCount: 5, // possible values are odd 5..21
    pageSize: 7,
    total: 0,
    currentPage: 1
  }),
  computed: {
    ...mapState({
      records: state => state.records.records,
      currentRecord: state => state.records.currentRecord
    }),
    filterRecords() {
      return status => {
        if (this.records) {
          return this.records.filter(record => {
            return this.$helpers.recordStatusMapper(record, status)
          })
        } else {
          return null
        }
      }
    },
    tabs() {
      return [
        {
          value: 'all',
          label: this.$t('records.grid.all')
        },
        {
          value: 'ongoing',
          label: this.$t('records.grid.ongoing')
        },
        {
          value: 'done',
          label: this.$t('records.grid.done')
        },
        {
          value: 'refused',
          label: this.$t('records.grid.refused')
        }
      ]
    }
  },
  watch: {
    activeName: {
      immediate: true,
      handler(newVal) {
        this.currentPage = 1
      }
    }
  },
  methods: {
    updateDialog(recordId) {
      this.dialogRecord = recordId
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.dialogRecord = null
    },
    updateRecord(updated) {
      let record = this.records.filter(record => record.id === updated.id)[0]


      if (record.state !== updated.state) {
        record.state = updated.state
        record.state_label = updated.state_label
        record.status = updated.status
        record.status_label = updated.status_label
      }
    },
    paginatedRecords() {
      const records = this.filterRecords(this.activeName)
      if (records) {
        this.total = records.length
        return records.slice((this.currentPage - 1) * this.pageSize, (this.currentPage - 1) * this.pageSize + this.pageSize)
      } else {
        return null
      }
    },
    currentPageChange(currentPage) {
      this.currentPage = currentPage
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.recordsTable';

#{$c} {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  &__tabs {
    width: 100%;
  }

  .el-pagination {
    margin-bottom: 40px;
    @include respond-above(lg) {
      margin-bottom: 0;
    }
  }
}
</style>